import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { ConfigType } from './data-config'; // TODO: Need to refactor

export var DisplayStatusTranslation;

(function (DisplayStatusTranslation) {
  DisplayStatusTranslation["upComing"] = "S\u1EAFp di\u1EC5n ra";
  DisplayStatusTranslation["onGoing"] = "\u0110ang di\u1EC5n ra";
  DisplayStatusTranslation["ended"] = "K\u1EBFt th\xFAc";
  DisplayStatusTranslation["publishedScore"] = "\u0110\xE3 c\xF4ng b\u1ED1 \u0111i\u1EC3m";
  DisplayStatusTranslation["grading"] = "Ch\u1EDD ch\u1EA5m \u0111i\u1EC3m";
})(DisplayStatusTranslation || (DisplayStatusTranslation = {}));

export var AssignmentDisplayStatus = /*#__PURE__*/function (_ConfigType) {
  _inherits(AssignmentDisplayStatus, _ConfigType);

  var _super = _createSuper(AssignmentDisplayStatus);

  function AssignmentDisplayStatus() {
    _classCallCheck(this, AssignmentDisplayStatus);

    return _super.apply(this, arguments);
  }

  return AssignmentDisplayStatus;
}(ConfigType);